module.exports = __webpack_public_path__ + "static/media/metallicgold1.53763f04.PNG";